<template>
  <div>

    <BreadCrumbs 
      :children="[
        {
          text: `OnBoarding del APP`,
        }
      ]"/>

    <div class="row ml-1">
      <div class="col-sm-12 text-left">
        <router-link :to="`/onboarding/0`" class="btn mr-1 main-bg">
          Nuevo
        </router-link>
      </div>
    </div>

    <div class="card ml-15">
      <div class="card-body">

        <div v-if="loading" class="text-center">
          <Loader />
        </div>
        <div v-else class="table-wraper">
          <table class="table">
            <thead class="thead-light">
              <tr>
                <th class="text-center">Version del APP</th>
                <th class="text-center">Número de slides</th>
                <th>Fecha</th>
                <th class="text-center">Opciones</th>
              </tr>  
            </thead>
            <tbody>
              <tr v-for="x in onboardings" :key="x.id">
                <td class="text-center">{{ x.version }}</td>
                <td class="text-center">{{ x.slides_count }}</td>
                <td>{{ x.date }}</td>
                <td class="text-center">
                  <router-link :to="`/onboarding/${x.id}`" class="text-primary mr-3" title="Ver detalles">
                    <i class="fa fa-eye"></i>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import BreadCrumbs from '../components/Breadcrumbs'
import Loader from '../components/Loader'
import { UtilsService } from '../../services/UtilsService';

export default {
  name: 'OnBoarding',
  components: { 
    BreadCrumbs,
    Loader 
  },
  data(){
    return {
      utilsService: new UtilsService(),
      loading: false,
      onboardings: []
    }
  },
  methods: {
    async get(){
      this.loading = true;
      const res = await this.utilsService.getOnBoarding();
      if(res.ok){
        this.onboardings = res.data;
      }else{
        this.$helpers.message('Error', res.message, 'error');
      }
      this.loading = false;
    },
  },
  beforeMount(){
    this.get();
  }
}
</script>

<style scoped>
tbody td{
  font-weight: 500 !important;
}
.fa{
  font-size: 1.2rem;
}
</style>